module.exports = __webpack_public_path__ + "static/img/werewolf.6e11587.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/werewolf.png
// module id = R9G3
// module chunks = 0